import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const logoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGOUT_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.LOGOUT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.LOGOUT_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default logoutReducer;
